var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06592 12.1422L1.41992 3.08418C1.28913 2.75992 1.29161 2.39715 1.4268 2.07471C1.562 1.75226 1.81898 1.4962 2.14192 1.36218C2.33951 1.28123 2.554 1.2502 2.76643 1.27182C2.97886 1.29345 3.1827 1.36707 3.35992 1.48618L17.5399 11.0402C17.8297 11.237 18.0303 11.54 18.0982 11.8837C18.1661 12.2273 18.096 12.5839 17.9029 12.8762C17.8028 13.0285 17.672 13.1582 17.5189 13.2572L3.35692 22.7982C3.21398 22.8948 3.05322 22.962 2.88404 22.9959C2.71486 23.0297 2.54064 23.0296 2.37151 22.9954C2.20239 22.9613 2.04176 22.8938 1.89899 22.7969C1.75621 22.7 1.63415 22.5757 1.53992 22.4312C1.41456 22.2418 1.33958 22.0236 1.32208 21.7972C1.30459 21.5707 1.34515 21.3436 1.43992 21.1372L5.06592 12.1422Z",
    stroke: "#122D5B",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 18.2182L14.421 12.2092L5.5 6.2002L7.92101 12.2092L5.5 18.2182Z",
    fill: "#FF9900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.483,
    height: 23.274,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/Subscription.42a44a869064565919d243e4d0aea332.svg";
export { ForwardRef as ReactComponent };